import type { DialogProps } from "@mui/material";
import { Dialog } from "@mui/material";

const SmallDialog = (props: DialogProps) => {
  return <Dialog slotProps={{ paper: { sx: { width: "32.5rem" } } }} {...props} />;
};

export default SmallDialog;
